import { defineStore } from "pinia";

import { EtabProfileService, EtabSubscriptionService } from "@core/services";
import { PaymentSessionModel, SubscriptionOffersModel, SubscribedInformationsModel } from "@core/models";
import {
  ACTION_SUBSCRIBED_GET_INFORMATIONS,
  ACTION_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS,
  ACTION_SUBSCRIPTION_SELECT_OFFER,
  ACTION_SUBSCRIPTION_GET_PAYMENT_SESSION,
  ACTION_SUBSCRIPTION_GET_PAYMENT_LINK,
  ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION,
  GETTER_SUBSCRIBED_GET_INFORMATIONS,
  GETTER_SUBSCRIPTION_HAS_SUBSCRIPTION,
  GETTER_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS,
  GETTER_SUBSCRIPTION_GET_SELECTED_OFFER,
  GETTER_SUBSCRIPTION_GET_PAYMENT_SESSION,
  GETTER_SUBSCRIPTION_GET_PAYMENT_LINK,
} from "@etab/stores/types";

export const useSubscriptionStore = defineStore("subscription", {
  // convert to a function
  state: () => ({
    offers: [],
    selectedOffer: {},
    paymentSessions: [],
    paymentLink: "",
    chosenGCL: false,
    informations: {},
    hasSubscriptionActive: null,
  }),
  getters: {
    [GETTER_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS]: (state) => state.offers.map((offer) => new SubscriptionOffersModel(offer)),
    [GETTER_SUBSCRIPTION_GET_SELECTED_OFFER]: (state) => new SubscriptionOffersModel(state.selectedOffer),
    [GETTER_SUBSCRIPTION_GET_PAYMENT_SESSION]: (state) => state.paymentSessions.map((session) => new PaymentSessionModel(session)),
    [GETTER_SUBSCRIPTION_GET_PAYMENT_LINK]: (state) => state.paymentLink,
    [GETTER_SUBSCRIPTION_HAS_SUBSCRIPTION]: (state) => state.hasSubscriptionActive,
    [GETTER_SUBSCRIBED_GET_INFORMATIONS]: (state) => new SubscribedInformationsModel(state.informations),
  },
  actions: {
    async [ACTION_SUBSCRIPTION_GET_SUBSCRIPTION_OFFERS](demandId) {
      const offers = await EtabSubscriptionService.getSubscriptionOffers(demandId);
      this.offers = offers;
    },
    [ACTION_SUBSCRIPTION_SELECT_OFFER](offer) {
      this.selectedOffer = offer;
    },
    async [ACTION_SUBSCRIPTION_GET_PAYMENT_SESSION](offerId) {
      const paymentSessions = await EtabSubscriptionService.getPaymentSessions(offerId);
      this.paymentSessions = paymentSessions;
    },
    async [ACTION_SUBSCRIPTION_GET_PAYMENT_LINK]({ code, offerId }) {
      const paymentLink = await EtabSubscriptionService.getPaymentLink({ offerId, code });
      this.paymentLink = paymentLink;
    },
    async [ACTION_SUBSCRIBED_GET_INFORMATIONS]() {
      const informations = await EtabSubscriptionService.getSubscribedInformations();
      this.informations = informations;
    },
    async [ACTION_SUBSCRIPTION_HAS_SUBSCRIPTION]() {
      const hasSubscriptionActive = await EtabProfileService.hasActiveSubscription();
      this.hasSubscriptionActive = hasSubscriptionActive;
    },
    // easily reset state using `$reset`
    clearSubscriptionStore() {
      this.$reset();
    },
  },
});
